import Image from 'next/image';

export default function BestsellerIcon({
  src,
  className = '',
}: {
  src?: string;
  className?: string;
}) {
  if (!src) return null;

  return (
    <Image
      src={src}
      alt=""
      width={32}
      height={32}
      unoptimized
      aria-hidden
      className={`shrink-0 object-contain ${className}`}
    />
  );
}
